export const ASSIGN_TAG = "ASSIGN_TAG";
export const UNASSIGN_TAG = "UNASSIGN_TAG";
export const UNASSIGN_TAG_WARNING = "UNASSIGN_TAG_WARNING";
export const DELETE_CATEGORY_WARNING = "DELETE_CATEGORY_WARNING";
export const DELETE_SUBCATEGORY_WARNING = "DELETE_SUBCATEGORY_WARNING";
export const DELETE_SUBCATEGORY_TAG_WARNING = "DELETE_SUBCATEGORY_TAG_WARNING";
